jQuery(function ($) {

  function updateToolbar(slick, currentSlide) {
    const $slider = slick.$slider;
    const $toolbar = $slider.next('.slider-toolbar');
    if (!$toolbar.length) return;

    const totalSlides = slick.slideCount || 1;
    const slidesToShow = Math.max(1, Number(slick.options.slidesToShow) || 1);
    const current = typeof currentSlide === 'number'
      ? currentSlide
      : slick.currentSlide || 0;

    // Paging
    const displayIndex = Math.min(current + 1, totalSlides);
    $toolbar.find('.pagingInfo').text(displayIndex + '/' + totalSlides);

    // ✅ FIXED maxIndex
    const maxIndex = Math.max(0, Math.ceil(totalSlides - slidesToShow));

    const isPrevDisabled = current <= 0;
    const isNextDisabled = current >= maxIndex;

    $toolbar.find('.slick-prev-btn')
      .prop('disabled', isPrevDisabled)
      .toggleClass('is-disabled', isPrevDisabled);

    $toolbar.find('.slick-next-btn')
      .prop('disabled', isNextDisabled)
      .toggleClass('is-disabled', isNextDisabled);

    // Scrollbar
    const $track = $toolbar.find('.scroll-track');
    const $thumb = $toolbar.find('.scroll-thumb');
    if (!$track.length || !$thumb.length) return;

    const trackWidth = $track.width();

    // Prevent weird ratio issues
    const safeTotal = Math.max(totalSlides, slidesToShow);

    const thumbWidth = trackWidth * (slidesToShow / safeTotal);
    $thumb.width(thumbWidth);

    const maxThumbMove = Math.max(0, trackWidth - thumbWidth);

    let left = maxIndex > 0
      ? (current / maxIndex) * maxThumbMove
      : 0;

    // ✅ HARD CLAMP (key fix)
    left = Math.max(0, Math.min(maxThumbMove, left));

    if (document.documentElement.dir === 'rtl') {
      $thumb.css({ right: left + 'px', left: '' });
    } else {
      $thumb.css({ left: left + 'px', right: '' });
    }
  }

  // ✅ ACCESSIBILITY FIX
  function manageSlideFocus(slick) {
    const $slides = $(slick.$slides);

    $slides.each(function () {
      const $slide = $(this);
      const isHidden = $slide.attr('aria-hidden') === 'true';

      const $focusables = $slide.find(
        'a, button, input, select, textarea, [tabindex]'
      );

      if (isHidden) {
        $focusables.attr('tabindex', '-1');
      } else {
        $focusables.removeAttr('tabindex');
      }
    });
  }

  function initSlider($slider) {
    if (!$slider.length) return;

    const $toolbar = $slider.next('.slider-toolbar');
    if (!$toolbar.length) return;

    const $prevBtn = $toolbar.find('.slick-prev-btn');
    const $nextBtn = $toolbar.find('.slick-next-btn');
    const $track = $toolbar.find('.scroll-track');
    const $thumb = $toolbar.find('.scroll-thumb');

    if ($slider.hasClass('slick-initialized')) {
      const slick = $slider.slick('getSlick');
      updateToolbar(slick, slick.currentSlide || 0);
      manageSlideFocus(slick);
      return;
    }

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      updateToolbar(slick, currentSlide);
      manageSlideFocus(slick);
    });

    $slider.on('beforeChange', function (event, slick) {
      manageSlideFocus(slick);
    });

    $slider.slick({
      rtl: document.documentElement.dir === 'rtl',
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: false,
      arrows: false,
      dots: false,
      speed: 400,
      swipeToSlide: true,
      accessibility: true,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 6.1 } },
        { breakpoint: 1024, settings: { slidesToShow: 4.5 } },
        { breakpoint: 990,  settings: { slidesToShow: 3.2 } },
        { breakpoint: 750,  settings: { slidesToShow: 2.2 } },
        { breakpoint: 480,  settings: { slidesToShow: 2.1 } }
      ]
    });

    // Arrows
    $prevBtn.off('click').on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });

    $nextBtn.off('click').on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });

    // ===== DRAG =====
    let isDragging = false;
    let startX = 0;
    let startLeft = 0;
    let animationFrame = null;

    function goToPercent(percent) {
      const slick = $slider.slick('getSlick');
      const totalSlides = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow;

      // ✅ FIXED maxIndex here too
      const maxIndex = Math.max(0, Math.ceil(totalSlides - slidesToShow));

      const targetIndex = Math.round(percent * maxIndex);
      $slider.slick('slickGoTo', targetIndex, false);
    }

    function updateFromPosition(newLeft) {
      const trackWidth = $track.width();
      const thumbWidth = $thumb.width();
      const maxMove = Math.max(0, trackWidth - thumbWidth);

      newLeft = Math.max(0, Math.min(maxMove, newLeft));

      const percent = maxMove > 0 ? newLeft / maxMove : 0;
      goToPercent(percent);
    }

    $thumb.on('mousedown touchstart', function (e) {
      isDragging = true;
      $thumb.css('transition', 'none');

      startX = e.type === 'touchstart'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      startLeft = document.documentElement.dir === 'rtl'
        ? parseFloat($thumb.css('right')) || 0
        : parseFloat($thumb.css('left')) || 0;

      e.preventDefault();
    });

    $(document).on('mousemove touchmove', function (e) {
      if (!isDragging) return;

      const clientX = e.type === 'touchmove'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      const delta = document.documentElement.dir === 'rtl'
        ? startX - clientX
        : clientX - startX;

      const newLeft = startLeft + delta;

      if (animationFrame) cancelAnimationFrame(animationFrame);

      animationFrame = requestAnimationFrame(function () {
        updateFromPosition(newLeft);
      });
    });

    $(document).on('mouseup touchend', function () {
      if (!isDragging) return;
      isDragging = false;

      $thumb.css(
        'transition',
        document.documentElement.dir === 'rtl'
          ? 'right 0.25s ease'
          : 'left 0.25s ease'
      );
    });

    // Track click
    $track.on('click', function (e) {
      if ($(e.target).is('.scroll-thumb')) return;

      const isRTL = document.documentElement.dir === 'rtl';
      const trackOffset = $track.offset();
      const trackWidth = $track.width();

      const clickX = isRTL
        ? (trackOffset.left + trackWidth) - e.clientX
        : e.clientX - trackOffset.left;

      const percent = Math.max(0, Math.min(1, clickX / trackWidth));
      goToPercent(percent);
    });

    // Initial sync
    setTimeout(function () {
      const slick = $slider.slick('getSlick');
      updateToolbar(slick, slick.currentSlide || 0);
      manageSlideFocus(slick);
    }, 0);

    $slider.on('breakpoint', function (event, slick) {
      setTimeout(function () {
        updateToolbar(slick, slick.currentSlide || 0);
        manageSlideFocus(slick);
      }, 0);
    });
  }

  // Init all
  $('.products-slick-vs').each(function () {
    initSlider($(this));
  });

  document.addEventListener('shopify:section:load', function (event) {
    $(event.target)
      .find('.products-slick-vs')
      .each(function () {
        initSlider($(this));
      });
  });

  // Prevent disabled arrow click
  $(document).on('click', '.slick-prev-btn.is-disabled, .slick-next-btn.is-disabled', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  });

});